import { typeInchat } from 'constants/channels'
import { lang } from './helpers'

const _ = require('lodash')

/* eslint-disable no-useless-escape */
//const URL_REGEX = /(?:https:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+/g
const URL_REGEX = /(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g
const TEXT_REGEX = /undefined/g
const TAG_A_REGEX = /<a[^>]+(.*?)a>/g
const REG_PHONE_WITH_CODE = /^\+\d*$/

/**
 * Return de correct name of user
 * @param {Object} user
 */
const showName = (user) => {
  const { name, provider_id = '', provider_name, channels } = user

  if (!name || TEXT_REGEX.test(name) || name.toLowerCase() === 'no name') {
    const channelOrigin = channels?.[0]?.origin
    const channel = channels?.[0]?.channel
    const provider = channels?.[0]?.provider

    if (provider === 'chatmail') return channelOrigin

    switch (channel || provider_name) {
      case 'sms':
        return `+${channelOrigin || provider_id.slice(3)}`
      case 'whatsapp':
        return `+${channelOrigin || provider_id.slice(11)}`
      case 'telegram':
        return channelOrigin || provider_id.slice(3)
      case 'facebook':
      case 'instagram':
      case 'instagram_post':
      case 'facebook_post':
        return channelOrigin || provider_id
      case 'ios':
        return channelOrigin || provider_id.slice(4)
      case 'android':
        return channelOrigin || provider_id.slice(8)
      case 'chatweb':
        return channelOrigin || provider_id.slice(4)
      case 'wall':
        return channelOrigin
      default:
        return null
    }
  }

  return name
}

/**
 * Return de correct channel to display
 * @param {String} channel
 */
const showChannel = (channel) => {
  if (!channel) return 'No channel'

  switch (channel) {
    case 'twilio':
      return 'SMS'
    default:
      return channel
  }
}

/**
 * Search if text contain an url and return a link.
 * @param {String} text
 */
const showLinkMessages = (text, label, provider) => {
  if (!text) return ''
  const tempLinks = []
  let index = -1
  const linkTagA = text.replace(TAG_A_REGEX, (link) => {
    index++
    tempLinks.push({ link: link, linkTemp: `${index}link` })
    return `${index}link`
  })

  if(linkTagA.match(REG_PHONE_WITH_CODE)) {
    let phoneText = linkTagA.replace(REG_PHONE_WITH_CODE, (phone) => {
      let t = ''
      if (label) t += `<span class='twillo-label'>${label}:</span><br/>`

      return `${t}<span>${phone}</span>`
    })

    return phoneText
  }

  let linkText = linkTagA.replace(URL_REGEX, (url) => {
    const fullUrl = !url.match('^https?://') ? `http://${url}` : url
    if (provider === 'telegram' || provider === 'facebook' || provider === 'wall')
      return `<a class='button-url text-ellipsis' href=${fullUrl} target="_blank">${label || lang('dashboard_url')}</a>`
    else {
      if (provider)
        return `<span class='twillo-label'>${label}:</span><br/><a class='twillo-url' href=${fullUrl} target="_blank" title=${fullUrl}>${fullUrl}</a>`
      else
        return `<a class='new-button-url text-ellipsis' href=${fullUrl} target="_blank" title=${fullUrl}>${label || fullUrl.substring(0, 20)}...</a>`
    }
  })
  tempLinks.forEach((it) => {
    linkText = _.replace(linkText, it.linkTemp, it.link)
  })

  const newText = linkText.replace(TEXT_REGEX, `<small class="text-muted">${lang('dashboard_button')}</small>`)

  return newText
}

/**
 * Find the email of the operator assigned to a user
 * @param {Array} ids
 * @param {Array} operators
 */
const getOperatorAssigned = (operators = []) => {
  return operators.map((item) => item.email).join(', ')
}

/**
 * Find the name of Company, Brand or Delegations.
 * @param {String} id
 * @param {String} id
 * @param {String} id
 * @param {String} id
 * @param {String} id
 * @param {String} id
 * @param {String} id
 * @param {Array} items
 * @param {Array} items
 * @param {Array} items
 * @param {Array} items
 * @param {Array} items
 * @param {Array} items
 * @param {Array} items
 */
const getNameBusiness = (id, items = []) => {
  const item = items.find((c) => c._id === id) || { name: '' }
  return item.name || ''
}

export const getNamesCardInChat = (users = [], type, name) => {
  let text = ''
  if(typeInchat.includes(type)){
    text = name || ''
    return text
  }
  if(users.length === 1){
    text =`${users[0].name || ''} ${users[0].lastname || ''}`
  }else if(users.length >= 2){
    const textArr = []
    users.forEach(user => {
      textArr.push(`${user.name || ''} ${!user.status? `(${lang('dashboard_deactivated')})` : ''}`)
    })
    text = textArr.join(', ')
  }
  return text
}

export default {
  showName,
  showChannel,
  showLinkMessages,
  getOperatorAssigned,
  getNameBusiness,
}
